import styled from '@emotion/styled'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { colors as nightlyColors } from '../../../../../design-tokens/src/thenightly/colors'

export const StyledNavItem = styled.li({
    display: 'block',
    '&:hover a': {
        color: nightlyColors.palette.starlight.default,
    },
})
